import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "buttonText"]
  static values = { allSelectedText: { default: "All", type: String } }

  connect() {
    this.initBlankText()
    this.toggledOption()
  }

  initBlankText() {
    if (!this.hasButtonTextTarget) {
      return
    }

    this.noneSelectedText = this.buttonTextTarget.innerText
  }

  toggledOption() {
    if (!this.hasButtonTextTarget) {
      return
    }

    const selected = this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) =>
        this.element.querySelector(`label[for="${cb.id}"]`).innerText.trim().replace(/\s+/g, " ")
      )

    if (selected.length === 0) {
      this.buttonTextTarget.innerText = this.noneSelectedText
    } else if (selected.length === this.checkboxTargets.length) {
      this.buttonTextTarget.innerText = this.allSelectedTextValue
    } else if (selected.length > 2) {
      this.buttonTextTarget.innerText =
        selected.slice(0, 2).join(", ") + `, and ${selected.length - 2} more`
    } else {
      this.buttonTextTarget.innerText = selected.join(", ")
    }
  }
}
